import { type FC, type ReactNode } from "react";

import { isDev, isLocal } from "../shared/constants";

export const DevToolsGuard: FC<{ children?: ReactNode }> = ({ children }) => {
    if (!isLocal() && !isDev()) {
        return null;
    }

    return <>{children}</>;
};
